exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.spinner[data-v-ee81178e] {\n  position: absolute;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 100vh;\n  width: 100vw;\n  background-color: white;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.spinner img[data-v-ee81178e] {\n    width: 120px;\n    height: 120px;\n    animation: spin 1000ms linear infinite;\n}\n@keyframes spin {\n100% {\n    transform: rotate(360deg);\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-ee81178e","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/sass-resources-loader/lib/loader.js?{"resources":"/builds/trek10-siemens/portal-frontend/static/styles/settings.scss"}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Callback.vue
// module id = 432
// module chunks = 1